import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { ScreenWidth } from 'web-common/src/shared/styles';

export const HOMEPAGE_WIDTH_MEDIUM = 885;
export const HOMEPAGE_WIDTH_LARGE = 960;
export const MaxHomepageWidth = styled.div`
  width: 100%;
  ${minScreen(ScreenWidth.MEDIUM)} {
    width: ${HOMEPAGE_WIDTH_MEDIUM}px;
  }
  ${minScreen(ScreenWidth.LARGE)} {
    width: ${HOMEPAGE_WIDTH_LARGE}px;
  }
`;
